<template>
    <div class="col-xl-12 col-sm-6 xl-100 box-col-12">
        <div class="card">
            <div class="card-header" id="social-bar-tour">
                <h3 class="p-0">
                    <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon8"
                        :aria-expanded="isActive ? 'true' : 'false'" aria-controls="collapseicon8"
                        :class="[isActive ? 'active' : '']" v-on:click="toggle">Followers</button>
                </h3>
            </div>
            <div :class="[isActive ? 'block' : ' show']" v-show="isActive">
                <div class="card-body social-list filter-cards-view">
                    <div class="d-flex" v-for="(item, index) in data.slice(1, 6)" :key="index"><img
                            class="img-50 img-fluid m-r-20 rounded-circle" alt="" :src="getImgUrl(item.thumb)">
                        <div class="flex-grow-1"><span class="d-block">{{ item.name }}</span><a
                                href="javascript:void(0)">Add
                                Friend</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-12 col-sm-6 xl-100 box-col-12">
        <div class="card">
            <div class="card-header">
                <h3 class="p-0">
                    <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon11"
                        :aria-expanded="isActive1 ? 'true' : 'false'" aria-controls="collapseicon11"
                        :class="[isActive1 ? 'active' : '']" v-on:click="toggle1">Followings</button>
                </h3>
            </div>
            <div :class="[isActive1 ? 'block' : ' show']" v-show="isActive1">
                <div class="card-body social-list filter-cards-view">
                    <div class="d-flex" v-for="(item, index) in data.slice(3, 8)" :key="index"><img
                            class="img-50 img-fluid m-r-20 rounded-circle" alt="" :src="getImgUrl(item.thumb)">
                        <div class="flex-grow-1"><span class="d-block">{{ item.name }}</span><a
                                href="javascript:void(0)">Add
                                Friend</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-12 col-sm-6 xl-100 box-col-12">
        <div class="card">
            <div class="card-header">
                <h3 class="p-0">
                    <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon4"
                        :aria-expanded="isActive2 ? 'true' : 'false'" aria-controls="collapseicon4"
                        :class="[isActive2 ? 'active' : '']" v-on:click="toggle2">Latest Photos</button>
                </h3>
            </div>
            <div :class="[isActive2 ? 'block' : ' show']" v-show="isActive2">
                <div class="card-body photos filter-cards-view">
                    <ul>
                        <li v-for="index in pic" :key="index">
                            <div class="latest-post"><img class="img-fluid" alt="" :src="getImgUrl(index)"></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-12 col-sm-6 xl-100 box-col-12">
        <div class="card">
            <div class="card-header">
                <h3 class="p-0">
                    <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon13"
                        :aria-expanded="isActive3 ? 'true' : 'false'" aria-controls="collapseicon13"
                        :class="[isActive3 ? 'active' : '']" v-on:click="toggle3">Friends</button>
                </h3>
            </div>
            <div :class="[isActive3 ? 'block' : ' show']" v-show="isActive3">
                <div class="card-body avatar-showcase filter-cards-view">
                    <div class="d-inline-block friend-pic" v-for="(item, index) in data" :key="index"><img
                            class="img-50 rounded-circle" :src="getImgUrl(item.thumb)" alt="#"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { data } from '../../../data/chatmember.json'
export default {
    name: 'followersPage',
    data() {
        return {
            data: data,
            isActive: true, isActive1: true, isActive2: true, isActive3: true,
            pic: ['social-app/post-1.png', 'social-app/post-2.png', 'social-app/post-3.png', 'social-app/post-4.png', 'social-app/post-5.png', 'social-app/post-6.png', 'social-app/post-7.png', 'social-app/post-8.png']
        }
    },
    methods: {
        getImgUrl(path) {
            return require('../../../assets/images/' + path)
        },
        toggle() {
            this.isActive = !this.isActive
        },
        toggle1() {
            this.isActive1 = !this.isActive1
        },
        toggle2() {
            this.isActive2 = !this.isActive2
        },
        toggle3() {
            this.isActive3 = !this.isActive3
        },
    }
}
</script>